import { render, staticRenderFns } from "./ResultItem.vue?vue&type=template&id=ccba809a&scoped=true"
import script from "./ResultItem.vue?vue&type=script&lang=js"
export * from "./ResultItem.vue?vue&type=script&lang=js"
import style0 from "./ResultItem.vue?vue&type=style&index=0&id=ccba809a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccba809a",
  null
  
)

export default component.exports